import { trashbinRestoreAllRequest } from 'reactApp/modules/trashbin/trashbin.module';
import { store as reduxStore } from 'reactApp/store';

export const restoreAll = (): void => {
    reduxStore.dispatch(trashbinRestoreAllRequest());
};
